import React, { Component } from 'react'
import {
    Button,
    Col,
    Row,
} from 'reactstrap'

import './battle.scss'

import LoadingComponent from "./../../components/Loading/component"
import LoadingSimple from "./../../components/Loading/simple"

import { create, updateScore, renderBattle } from './../../services/battles'

import moment from 'moment-timezone'

import ReactGA from 'react-ga'

require('dotenv').config()

const {
    REACT_APP_GA_ANALYTICS
} = process.env

class BattlePage extends Component {
    state = {
        loading: true,
        alert: {
            status: false,
            message: '',
            color: ''
        },
        battle: [],
        topRatings: [],
        voting: false
    }

    componentDidMount = () => {
        this.renderNewBattle()
    }

    renderNewBattle = () => {
        ReactGA.initialize(REACT_APP_GA_ANALYTICS)
        ReactGA.pageview(window.location.pathname + window.location.search)
        let self = this

        renderBattle()
            .then(response => {
                self.setState({
                    loading: false,
                    voting: false,
                    battle: response.data.battle,
                    topRatings: response.data.topRatings
                })
            })
            .catch(err => {
                self.setState({
                    loading: false,
                    voting: false,
                    battle: []
                })
            })
    }

    handleVoting = async (winner, loser) => {
        this.setState({
            voting: true
        })

        let winnerExpected = this.expectedScore(loser.score, winner.score)
        let winnerNewScore = this.winnerScore(winner.score, winnerExpected)
        let loserExpected = this.expectedScore(winner.score, loser.score)
        let loserNewScore = this.loserScore(loser.score, loserExpected)

        ReactGA.event({
            category: 'battle',
            action: `${winner.snippet.title} ganhou de ${loser.snippet.title}`,
            label: 'Vote by User'
        })

        await updateScore(winner.id.videoId, winnerNewScore, 'win')
        await updateScore(loser.id.videoId, loserNewScore, 'lose')
        await create(winner.id.videoId, loser.id.videoId)

        this.renderNewBattle()
    }

    expectedScore = (Rb, Ra) => {
        return parseFloat((1 / (1 + Math.pow(10, (Rb - Ra) / 400))).toFixed(4))
    }

    winnerScore = (score, expected) => {
        return score + 24 * (1 - expected)
    }

    loserScore = (score, expected) => {
        return score + 24 * (0 - expected)
    }

    skipBattle = () => {
        ReactGA.event({
            category: 'battle',
            action: 'Usuário preferiu gerar uma nova batalha ao invés de votar nas duas',
            label: 'Skipped Battle'
        })
        this.setState({
            voting: true
        })
        this.renderNewBattle()
    }

    render() {
        const { loading, battle, voting, topRatings } = this.state

        if (loading) {
            return (
                <LoadingComponent />
            )
        }

        return (
            <>
                <Row className="text-center mt-3 mb-5">
                    <Col xs="12">
                        <h3>Batalha de Episódios!</h3>
                        <h2>Qual foi o melhor? Clique para votar.</h2>
                    </Col>
                </Row>
                {
                    !voting &&
                    <>
                        <Row className="text-center mt-2 mb-2">
                            <Col xs="6">
                                <div onClick={() => this.handleVoting(battle[0], battle[1])} className="video border rounded p-2">
                                    <div className="title">
                                        <h3>{battle[0].snippet.title}</h3>
                                    </div>
                                    <div className="thumb">
                                        <img src={battle[0].snippet.thumbnails.high.url} alt={battle[0].snippet.title} className="img-fluid rounded" />
                                    </div>
                                </div>
                            </Col>
                            <Col xs="6">
                                <div onClick={() => this.handleVoting(battle[1], battle[0])} className="video border rounded p-2">
                                    <div className="title">
                                        <h3>{battle[1].snippet.title}</h3>
                                    </div>
                                    <div className="thumb">
                                        <img src={battle[1].snippet.thumbnails.high.url} alt={battle[1].snippet.title} className="img-fluid rounded" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs='12' className="text-center mt-2 mb-2">
                                <Button onClick={() => this.skipBattle()} block color="warning">Gerar outra batalha!</Button>
                            </Col>
                        </Row>
                    </>
                }
                {
                    voting &&
                    <Row>
                        <Col xs="12">
                            <div className="border rounded p-5 text-center">
                                <LoadingSimple />
                            </div>
                        </Col>
                    </Row>
                }
                <Row className="text-center mt-4 mb-4">
                    <Col xs="12">
                        <h3>Top Episódios da Galera</h3>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <div className="d-flex flex-column mb-3">
                            {
                                topRatings.length > 0 && topRatings.map((video, i) => {
                                    return (
                                        <div key={i} className="p-2 border rounded mt-1 mb-1">
                                            <img src={video.snippet.thumbnails.default.url} className="img-fluid mb-2" alt={video.snippet.title} />
                                            <p><strong>{`${(i + 1)} lugar:`}</strong> {video.snippet.title} - {moment(video.snippet.publishedAt).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}</p>
                                            <p><strong>Pontuação:</strong> {video.score}</p>
                                            <p><strong>Venceu</strong> {(video.wins === 1 ? `${video.wins} vez` : `${video.wins} vezes`)}</p>
                                            <p><strong>Perdeu</strong> {(video.losses === 1 ? `${video.losses} vez` : `${video.losses} vezes`)}</p>
                                            <Button onClick={() => window.open(`https://www.youtube.com/watch?v=${video.id}`, "_blank")} color="primary">Assistir episódio</Button>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
            </>
        )
    }
}

export default BattlePage